import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import React from "react";
import { useParams } from "react-router-dom";
import ShowAttr from "../../components/ShowAttr";
import strings from "../../config/localization";
import { useGetAuditLogsByIdQuery } from "../../services/appln";

export default function AuditLogsDetails() {
  const { auditId } = useParams();
  const { data } = useGetAuditLogsByIdQuery({ auditId: auditId });
  console.log("Audit Id:", auditId);
  console.log("Data", data);
  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid margin={0} container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h5">{strings.details}</Typography>
        </Grid>
        {data ? (
          <>
            <ShowAttr label={strings.userId} value={data.userId} width={4} />
            <ShowAttr
              label={strings.parameters}
              value={data.parameters}
              width={4}
            />
            <ShowAttr label={strings.actions} value={data.action} width={4} />
            <ShowAttr
              label={strings.timestamp}
              value={data.timestamp}
              width={4}
            />
          </>
        ) : null}
      </Grid>
    </Box>
  );
}
